import { render, staticRenderFns } from "./ProjectsCarousel.vue?vue&type=template&id=34658dea&scoped=true"
import script from "./ProjectsCarousel.vue?vue&type=script&lang=js"
export * from "./ProjectsCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProjectsCarousel.vue?vue&type=style&index=0&id=34658dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34658dea",
  null
  
)

export default component.exports